<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Edit handler phone
      </h3>

      <validation-observer ref="handler-phone-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="phone"
              v-slot="{ errors }">
              <label for="id">Phone:</label>
              <d-input
                v-model="data.phone"
                :state="errors.length ? 'invalid' : null" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'HandlerPhonePopup',
  data () {
    return {
      isVisible: false,
      loading: false,
      data: {
        handler_id: null,
        airport_id: null,
        phone: ''
      }
    };
  },
  mounted () {
    this.$bus.$on('show-handler-phone-popup', this.show);
  },
  methods: {
    show (popupData) {
      this.data = {
        handler_id: popupData.handler_id,
        airport_id: popupData.airport_id,
        phone: popupData.phone
      };

      setTimeout(() => {
        this.$refs['handler-phone-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['handler-phone-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/handlers/set-phone/' + parseInt(this.data.handler_id, 10),
        formData: {
          airport_id: parseInt(this.data.airport_id, 10),
          phone: this.data.phone
        },
        successTitle: 'Phone number saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the phone number. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('handlers-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-handler-phone-popup', this.show);
  }
}
</script>
